export default function RecentActivity({ activityList = [] }) {
  return (
    <div className="card activity-card">
     <div className="d-flex align-items-start gap-3 mb-3">

  {/* Icon */}
  <div className="icon-box bg-secondary-light">
    <i className="fas fa-stream text-secondary"></i>
  </div>

  {/* Title + Subtitle */}
  <div>
    <h5 className="mb-1 fw-semibold">
      Recent Activity
    </h5>
    <p className="text-muted small mb-0">
      Your latest updates
    </p>
  </div>

</div>

      <ul className="activity-list">
        {activityList.length === 0 && (
          <p className="empty">No recent activity</p>
        )}

        {activityList.map((a, i) => (
          <li key={i}>
            <span className="icon">{a.icon}</span>
            <div>
              <p className="title">{a.title}</p>
              <p className="time">{a.time}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
